import { Button, Grid } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {
    getEnterpriseChart, getEnterpriseTable, getFarmReport,
    getWholeFarmReport,
    setLoading
} from '../../../../store/appAction';
import { useReactToPrint } from "react-to-print";
import { Container } from '@mui/system';
import Contents from './Contents';
import Charts from './Charts';
import Tables from './Tables';
import MainPage from '../Common/MainPage';
import '../../../../assets/fonts/Montserrat-VariableFont_wght-normal.js'
import { useLocation, } from 'react-router-dom';
import queryString from 'query-string';
import _ from 'lodash';
import { cssPrintHeader } from '../../../../helpers/pdfHelper';
import { showNonValidatedReportText, getEmissionsByGasChartData, checkAllLoaded } from '../../../../helpers/reportResultsHelper.js';

const Preview = () => {
    let location = useLocation();
    const dispatch = useDispatch();
    const farm = useSelector(state => state.adminFarm.farmDetails);
    const wfPdfDetailedResults = useSelector(state => state.wholeFarm.detailed);
    const farmPermissions = useSelector(state => state.auth.farmPermissions);
    const reportId = useSelector(state => state.common.reportId);
    const reportData = useSelector(state => state.farmReport.reportSettings);
    const chartData = useSelector(state => state.enterprise.chartData);
    const tableData = useSelector(state => state.enterprise.tableData);
    const printRef = useRef();

    useEffect(() => {
        dispatch(setLoading());

        const { reportEnterpriseSectorId, reportEnterpriseSectorGroupId,
            reportEnterpriseSectorItemId, reportComparisonType, referenceId,
        } = queryString.parse(location.search);

        dispatch(getFarmReport({ reportId }));
        dispatch(getEnterpriseChart({
            ReportId: reportId,
            ReportEnterpriseSectorId: reportEnterpriseSectorId,
            ReportEnterpriseSectorGroupId: reportEnterpriseSectorGroupId,
            ReportEnterpriseSectorItemId: reportEnterpriseSectorItemId,
            ReportComparisonType: reportComparisonType,
            ComparisonReferenceId: referenceId,
        }));
        dispatch(getEnterpriseTable({
            ReportId: reportId,
            ReportEnterpriseSectorId: reportEnterpriseSectorId,
            ReportEnterpriseSectorGroupId: reportEnterpriseSectorGroupId,
            ReportEnterpriseSectorItemId: reportEnterpriseSectorItemId,
            ReportComparisonType: reportComparisonType,
            ComparisonReferenceId: referenceId,
        }));
        dispatch(getWholeFarmReport({
            reportId: reportId,
            reportComparisonType: reportComparisonType,
            comparisonReferenceId: referenceId,
        })); //wfDetailedResults
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportId]);

    useEffect(() => {
        checkAllLoaded([reportData, chartData, tableData, wfPdfDetailedResults],dispatch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportData, chartData, tableData, wfPdfDetailedResults]);

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        copyStyles: true,
        pageStyle: cssPrintHeader(farm, reportData, chartData),
        removeAfterPrint: true,
        documentTitle: `Agrecalc report - [${reportData?.friendlyReportId}].pdf`
    });

    const ReportPreview = () => {
        let chartDataFix = chartData
        if (chartDataFix && !_.isEmpty(chartDataFix) && tableData && !_.isEmpty(tableData)
            && wfPdfDetailedResults && !_.isEmpty(wfPdfDetailedResults)) {
            let wfDetailedResults = wfPdfDetailedResults?.wholeFarmReportResult?.wholeFarmDetailedResult
            if (wfDetailedResults) {
                let ebg = getEmissionsByGasChartData(wfDetailedResults, tableData.enterpriseTitle);
                chartDataFix.emissionByGas = [...ebg];
            }

        }

        return (
            <Container sx={{ pointerEvents: 'none' }}>
                <Grid ref={printRef} className='to-pdf' container px={2} my={2}>
                    <MainPage
                        isEnterprise={true}
                        farmId={farm?.friendlyFarmId}
                        farmName={farm?.farmName}
                        reportId={reportData?.friendlyReportId}
                        reportName={reportData?.reportName}
                        reportingPeriodEnd={tableData?.reportingPeriodEnd}
                        modelNumber={chartDataFix?.calculatorReportVersion}
                        yearEnd={reportData?.yearEnd}
                        reportLogoUrl={tableData?.reportLogoUrl}
                        config={tableData}
                        permissions={farmPermissions}
                        coefficientSheetName={reportData?.coefficientSheetName}
                        status={reportData?.status}
                        showNonValidatedReportText={showNonValidatedReportText(reportData?.status)}
                    />
                    <Charts chartsResults={chartDataFix} results={tableData} />
                    <Tables results={tableData} firstChild={true} />
                    <Contents firstChild={true} />
                </Grid >
            </Container >
        )
    };

    return (
        <Container
            sx={{
                width: '950px',
            }} p={0}>
            <Grid container direction='row' spacing={0}>
                <Grid item xs={12} mb={3}>
                    <Button
                        variant="contained"
                        sx={{ textTransform: 'none', marginTop: '23px', float: 'right' }}
                        onClick={()=>handlePrint()}
                    >
                        Print
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Container
                        sx={{
                            py: 4,
                            height: '1280px',
                            width: '900px',
                            overflow: 'scroll',
                            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
                        }}>
                        <ReportPreview />
                    </Container>
                </Grid>
            </Grid>
        </Container >
    )
}

export default Preview